module.exports = __webpack_public_path__ + "media/images/home/fausto_btc___-f391f63df187ea7343dd8b6ffcf5e8d5.png";